
import {Vue, Component, Prop} from 'vue-property-decorator';
import moment from "moment";
import Template from "@/views/system-management/template/index.vue";

@Component({
  name: "MaintainPaymentInfo",
  components: {
    Template,
  }
})
export default class extends Vue {
  @Prop({ default: {} }) private source: any;
  @Prop({ default: 0 }) private index: number;
  @Prop({ default: [] })private paymentMethodOptions;

  paymentForm = {
    paymentMethod: null,
    paymentDetail: null,
    paymentRemark: null,
    deposit: false,
    depositAmount: null,
    tradingTerms: null,
    accountPeriod: null,
    deliveryTime: null,
    orderAuditor: null,
    hqDeliveryDays: null,
    depositPercent: null,
  };

  private cancelDeposit() {
    if (!this.source.deposit) {
      this.source.depositAmount = 0;
    }
  }

  private get deliveryDaysText() {
    const deliveryTime = this.source.deliveryTime;
    const purchaseOrderCreateTime = this.source.purchaseOrderCreateTime;
    if (!deliveryTime || !purchaseOrderCreateTime) {
      return "--";
    }
    const deliveryDate = this.parseDay(deliveryTime);
    const createDate = this.parseDay(purchaseOrderCreateTime);
    if (!deliveryDate || !createDate) {
      return "--";
    }
    return `${deliveryDate.diff(createDate, "days")}天`;
  }

  private get deliveryTimePickerOptions() {
    return {
      disabledDate: (time: Date) => {
        const currentDate = moment(time).startOf("day");
        const createDate = this.parseDay(this.source.purchaseOrderCreateTime);
        const piDeliveryDate = this.parseDay(this.source.piDeliveryDate);
        if (createDate && currentDate.isBefore(createDate)) {
          return true;
        }
        if (piDeliveryDate && currentDate.isAfter(piDeliveryDate)) {
          return true;
        }
        return false;
      },
    };
  }

  private handleDeliveryTimeChange(value?: string) {
    if (!value) {
      return;
    }
    const deliveryDate = this.parseDay(value);
    if (!deliveryDate) {
      return;
    }
    const createDate = this.parseDay(this.source.purchaseOrderCreateTime);
    if (createDate && deliveryDate.isBefore(createDate)) {
      this.source.deliveryTime = null;
      this.$message.warning("约定交期不能早于下单日期");
      return;
    }
    const piDeliveryDate = this.parseDay(this.source.piDeliveryDate);
    if (piDeliveryDate && deliveryDate.isAfter(piDeliveryDate)) {
      this.source.deliveryTime = null;
      this.$message.warning("约定交期不能晚于PI的交货日期");
    }
  }

  private parseDay(date?: string) {
    if (!date) {
      return null;
    }
    const normalizedDate = String(date).split(" ")[0].split("T")[0];
    const parsedDate = moment(normalizedDate, "YYYY-MM-DD", true).startOf("day");
    return parsedDate.isValid() ? parsedDate : null;
  }

  private formatPiDeliveryDate(date?: string) {
    const parsedDate = this.parseDay(date);
    if (!parsedDate) {
      return "--";
    }
    return parsedDate.format("YYYY年MM月DD日");
  }
}
